import { Component, inject, OnInit } from '@angular/core'
import {CommonModule} from "@angular/common";
import {
  NgbDropdown,
  NgbDropdownMenu,
  NgbDropdownToggle,
  NgbModal
} from "@ng-bootstrap/ng-bootstrap"
import {userDropdownItems, UserDropdownItemType} from '@layouts/components/data';
import {Router, RouterLink} from '@angular/router';
import {NgIcon} from '@ng-icons/core';
import { AuthService } from '@core/services/auth.service';
import { UserService } from "@/app/pages/principal/users/user.service"
import {
  ResetPasswordComponent
} from "@app/components/reset-password/reset-password.component"

@Component({
  selector: 'app-user-profile-topbar',
  imports: [
    CommonModule,
    NgbDropdown,
    NgbDropdownMenu,
    NgbDropdownToggle,
    RouterLink,
    NgIcon
  ],
  templateUrl: './user-profile.component.html'
})
export class UserProfileComponent implements OnInit {
  menuItems: (UserDropdownItemType & { action?: () => void })[] = [];
  user: any;
  private modal_svc=inject(NgbModal)
  constructor(
    private authService: AuthService,
    private router: Router
  ) {

    const actions: Record<string, () => void> = {
      logout: () => this.logout(),
      changepass:()=>this.changepass()
    };
    this.menuItems = userDropdownItems.map(item => ({
      ...item,
      action: item.actionKey ? actions[item.actionKey] : undefined
    }));
  }

  ngOnInit(): void {
    this.authService.getCurrentUser().subscribe(user => {
      this.user = user;
    });
  }

  logout() {
    this.authService.logout();
  }
  changepass(){
    const ref=this.modal_svc.open(ResetPasswordComponent)
    ref.closed.subscribe((rs)=>{
      if(rs){
        this.logout();
      }
    })
  }
}
